import { render } from "./MonthlyShiftLimitIcon.vue?vue&type=template&id=4f4b2d6e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__